<template>
  <v-container>
    <v-layout>
      <v-flex>
        <div class="headline primary--text">
          {{ $t('user_tags') }}
        </div>
      </v-flex>
      <v-flex class="default-input">
        <v-text-field
          id="search"
          v-model="search"
          name="search"
          single-line
          :placeholder="$t('Search')"
          outline
          clearable
          prepend-inner-icon="search"
          hide-details
          @blur="onSearchUserTag"
          @keydown.enter="onSearchUserTag"
          @input="onSearchUserTag"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <div class="mt-3">
      <apexchart
        ref="tagreport"
        type="bar"
        :height="chartHeight"
        width="100%"
        :options="options"
        :series="series"
      ></apexchart>
    </div>
  </v-container>
</template>

<script>
import analyticApi from '@/api/analytic'
import VueApexCharts from 'vue-apexcharts'
import { mapGetters } from 'vuex'
import { debounce } from 'lodash'

export default {
  components: { apexchart: VueApexCharts },
  data() {
    return {
      updateSearchTimeout: null,
      search: '',
      lastestSearch: null,
      tags: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    chartHeight() {
      const countTag = this.tags.length
      let height = 'auto'
      if (countTag > 500) {
        height = '6500'
      } else if (countTag > 200) {
        height = '3500'
      } else if (countTag > 100) {
        height = '3000'
      } else if (countTag > 35) {
        height = '2000'
      }
      return height
    },
    options() {
      return {
        chart: {
          id: 'vuechart-example'
        },
        colors: ['#52e3f9'],
        dataLabels: {
          style: {
            fontSize: '14px',
            fontWeight: 'bold',
            colors: ['#000']
          }
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        xaxis: {
          categories: this.tags.map((v) => v.tag)
        },
        yaxis: {
          opposite: false,
          labels: {
            maxWidth: 'auto'
          }
        }
      }
    },
    series() {
      return [
        {
          name: 'Total',
          data: this.tags.map((v) => v.count)
        }
      ]
    }
  },
  mounted() {
    this.onSearchUserTag = debounce(this.onSearchUserTag, 2000)
    this.onSearchUserTag()
  },
  methods: {
    async onSearchUserTag() {
      const vm = this
      try {
        if (vm.lastestSearch !== vm.search) {
          if (vm.updateSearchTimeout) {
            clearTimeout(vm.updateSearchTimeout)
          }
          const result = await vm.getUserTagReport()
          vm.lastestSearch = vm.search
          vm.tags = result
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.updateSearchTimeout = null
      }
    },
    async getUserTagReport() {
      const vm = this
      try {
        vm.$store.dispatch('loading')

        const response = await analyticApi.getUserTagReport({
          page_id: vm.selectedBot.pageid,
          params: {
            search: vm.search
          }
        })
        if (response && response.data && response.data.data) {
          return response.data.data
        } else {
          return []
        }
      } catch (error) {
        console.error(error)
        vm.$swal.fire({
          title: vm.$t('Error'),
          type: 'error'
        })
        return []
      } finally {
        vm.$store.dispatch('loading')
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/tisco/UserTags.vue